import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

interface Props {
  top?: number;
  left?: number;
  width?: number;
  height?: number;
}

const DescriptionMaskVertical = styled.div<Props>`
  background: linear-gradient(180deg, rgba(15, 15, 15, 0) 0%, #0f0f0f 50.54%);
  position: absolute;
  width: ${(props) => (props.width || 1029) * Screen.widthRatio}px;
  height: ${(props) => (props.height || 93) * Screen.widthRatio}px;
  left: ${(props) => (props.left || 877) * Screen.widthRatio}px;
  top: ${(props) => (props.top || 480) * Screen.widthRatio}px;
`;

export default DescriptionMaskVertical;
